import { render, staticRenderFns } from "./DomainNameservers.vue?vue&type=template&id=22722254&"
import script from "./DomainNameservers.vue?vue&type=script&lang=js&"
export * from "./DomainNameservers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports